import React from 'react';
import { CTAButton } from '../ui/CTAButton';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
import { ProgressBar } from '../ui/ProgressBar';
export function HeroSection() {
  return <section className="pt-8 pb-10 md:pt-[120px] md:pb-20 px-4 md:px-8 bg-ink min-h-[85vh] md:min-h-0 flex items-center" data-id="element-48">
      <div className="max-w-3xl mx-auto w-full flex flex-col items-center text-center" data-id="element-49">
        <span className="text-[10px] uppercase font-bold text-accent tracking-[0.2em] mb-3 block" data-id="element-50">
          LANZAMIENTO ESPECIAL
        </span>

        <h1 className="text-[clamp(32px,8vw,48px)] leading-[1.1] text-cream mb-4" data-id="element-51">
          Formulá cosméticos naturales con seguridad y resultados repetibles —
        </h1>

        <p className="text-[16px] md:text-[18px] text-cream mb-6 leading-[1.6]" data-id="element-52">
          <strong data-id="element-53">222 fórmulas organizadas.</strong> Criterios de seguridad
          incluidos. Sin adivinar proporciones.
          <br data-id="element-54" />
          La guía que ninguna receta de Pinterest tiene — y que siempre
          necesitaste.
        </p>

        <div className="w-full max-w-lg mb-6" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/vYBH1iBtHcPgMfHLQR8dbr/20260226_1941_Image_Generation_simple_compose_01kje1s901f0nt2fg5sqyw5pwe.png" alt="222 Cosméticos Naturales - Fórmulas Seguras y Rentables" className="w-full shadow-xl rounded-sm" data-id="element-56" />
        </div>

        <div className="flex flex-col gap-3 w-full md:w-auto md:inline-flex items-center" data-id="element-57">
          <CTAButton className="w-full md:max-w-md" data-id="element-58">
            → QUIERO MIS 222 FÓRMULAS AHORA
          </CTAButton>

          <div className="text-center mt-2" data-id="element-59">
            <p className="text-[12px] text-cream/70 mb-1" data-id="element-60">
              🔒 Pago 100% seguro · Descarga inmediata · Garantía 60 días
            </p>
            <p className="text-[13px] font-bold text-gold-star" data-id="element-61">
              ★★★★★{' '}
              <span className="text-cream/90 font-normal" data-id="element-62">
                Ya lo tienen más de 200 familias
              </span>
            </p>
          </div>

          <div className="mt-2" data-id="element-63">
            <ProgressBar data-id="element-64" />
          </div>
        </div>
      </div>
    </section>;
}